import React from 'react';

import { SkeletonItem as AtlassianSkeletonItem } from '@atlaskit/menu';
import type { SkeletonItemProps } from '@atlaskit/menu';

import { ContainerStyled } from './SkeletonItem.styled';

export type Props = SkeletonItemProps & {
  hasNoBar?: boolean;
  height?: string;
};

export default function SkeletonItem({
  width,
  height,
  hasNoBar = false,
  isShimmering = true,
  ...rest
}: Props): JSX.Element {
  return (
    <ContainerStyled width={width} hasNoBar={hasNoBar} height={height}>
      <AtlassianSkeletonItem
        width={width}
        isShimmering={isShimmering}
        {...rest}
      />
    </ContainerStyled>
  );
}
